// ===== MOCK DATA (development fallback) =====
//
// Used automatically when the PHP API (`/api/submissions.php`) is not
// reachable — e.g. running `npm run dev` without a database.
//
// Playback is SIMULATED, so no real audio files are referenced. Photos are
// rendered as per-guest duotone gradients (no image URLs). `hue` is optional;
// the gallery derives a stable hue per guest when it is absent.
//
// Shape consumed by the gallery:
//   { id, guestName, timestamp, duration (ms), caption, hue? }

export const mockSubmissions = [
    {
        id: 1,
        guestName: 'Aisha & Daniel',
        timestamp: '2:14 PM',
        duration: 18000,
        caption: 'Wishing you a lifetime of love and laughter',
        hue: 28,
    },
    {
        id: 2,
        guestName: 'The Tanaka Family',
        timestamp: '3:02 PM',
        duration: 24000,
        caption: 'From our family to yours, with all our love',
        hue: 62,
    },
    {
        id: 3,
        guestName: 'Marcus',
        timestamp: '3:48 PM',
        duration: 12000,
        caption: 'Best man duties, done',
        hue: 98,
    },
    {
        id: 4,
        guestName: 'Priya & Sam',
        timestamp: '4:20 PM',
        duration: 30000,
        caption: 'Two hearts, one beautiful journey',
        hue: 142,
    },
    {
        id: 5,
        guestName: 'Grandma Rose',
        timestamp: '4:55 PM',
        duration: 21000,
        caption: 'May your love grow sweeter with every year',
        hue: 188,
    },
    {
        id: 6,
        guestName: 'The Office Crew',
        timestamp: '5:30 PM',
        duration: 15000,
        caption: "Took you long enough!",
        hue: 224,
    },
    {
        id: 7,
        guestName: 'Leila',
        timestamp: '6:08 PM',
        duration: 27000,
        caption: 'Dancing the night away with my favourite people',
        hue: 268,
    },
    {
        id: 8,
        guestName: 'Uncle Joe',
        timestamp: '6:45 PM',
        duration: 19000,
        caption: 'Welcome to the family',
        hue: 308,
    },
    {
        id: 9,
        guestName: 'Nina & Theo',
        timestamp: '7:12 PM',
        duration: 22000,
        caption: 'Here is to love that feels like home',
        hue: 338,
    },
    {
        id: 10,
        guestName: 'The College Gang',
        timestamp: '7:50 PM',
        duration: 16000,
        caption: 'From dorm rooms to wedding bells',
        hue: 12,
    },
];
